import { colors } from '@sweep-io/sweep-design';

export const INACTIVE_USER_TXT_COLOR = colors.grey[500];
